import gql from "graphql-tag"

export const GET_HELP_CENTER = gql`
  query helpCenter($WhereInput: HelpWhereInput) {
    helpCenter(WhereInput: $WhereInput) {
      id
      description
      updatedAt
    }
  }
`
